<i18n src="@/locales/modules/DeviceChecklistTranslate.json"></i18n>

<template>
	<el-dialog
		append-to-body
		destroy-on-close
		:before-close="setDialogHide => handleCloseDialog(setDialogHide, isFormDirty)"
		class="custom-nested-dialog"
		:title="$t(dataId ? 'UpdateChecklistItem' : 'CreateChecklistItem')"
		:visible.sync="isPopupActiveLocal"
	>
		<div class="p-6">
			<label for class="vs-input--label">
				{{ $t("ChecklistItemName") }}
				<span class="text-danger">*</span>:
			</label>
			<v-select
				taggable
				:disabled="!!dataId"
				:ref="ref"
				label="name"
				:options="kpiv2s"
				:placeholder="`${$t('Actions.Choose')} ${$t('ChecklistItemName').toLowerCase()}`"
				class="bg-white"
				:closeOnSelect="true"
				:getOptionKey="option => ref + option.id"
				name="kpiv2s"
				v-model="kpi"
				:data-vv-as="$t('ChecklistItemName')"
				v-validate="{ required: true }"
				:create-option="newOptionText => handleAddingNewOption(newOptionText, kpiv2s)"
			>
				<template #no-options>
					{{ $t("PleaseInputToSearch") }}
				</template>
			</v-select>
			<span class="text-danger text-sm" v-show="errors.has('kpiv2s')">{{ errors.first("kpiv2s") }}</span>
			<!-- MaintainHour -->
			<div class="mt-5">
				<label for class="vs-input--label"> {{ $t("MaintainHour") }}: </label>
				<cbs-input
					type="number"
					v-model="maintainHrs"
					class="w-full"
					min="0"
					name="maintainHrs"
					:placeholder="`${$t('Actions.Input')} ${$t('MaintainHour')}`"
					v-validate="{ numeric: true, min_value: 0, required: kpi ? true : false }"
					:data-vv-as="$t('MaintainHour')"
				/>
				<span class="text-danger text-sm break-normal" v-show="errors.has('maintainHrs')">{{ errors.first("maintainHrs") }}</span>
			</div>
		</div>

		<div class="flex justify-center" slot="footer">
			<vs-button class="w-full sm:w-1/3 font-bold" @click.stop="submitData">
				{{ $t("Actions.Submit") }}
			</vs-button>
		</div>
	</el-dialog>
</template>

<script>
import _ from "lodash";
import vSelect from "vue-select";

export default {
	components: {
		"v-select": vSelect
	},
	props: {
		isPopupActive: {
			type: Boolean,
			required: true
		},

		data: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			dataId: null,
			dataName: "",
			categoryId: null,

			initFormData: {},
			isFormDirty: false,
			ref: "formCategoryV2",
			kpiv2s: [],
			maintainHrs: null,
			kpi: null
		};
	},
	watch: {
		isPopupActive(val) {
			if (!val) return;

			const { id, name, categoryId, maintain_hrs } = this.data;

			this.categoryId = categoryId;
			if (!this.data.id) {
				this.initValues();
			} else {
				this.dataId = id;
				this.dataName = name;
				this.kpi = { id: this.data.id, name: this.data.name };
				this.maintainHrs = maintain_hrs;
			}

			this.isFormDirty = false;
			this.initFormData = {
				dataId: this.dataId,
				dataName: this.dataName,
				categoryId: this.categoryId,
				kpi: this.kpi,
				maintainHrs: this.maintainHrs
			};
		},
		computedFormData: {
			handler: function(newVal) {
				if (!this.isFormDirty && newVal.kpi !== this.initFormData.kpi && newVal.dataId === this.initFormData.dataId) {
					this.isFormDirty = true;
				}
			},
			deep: true
		}
	},
	methods: {
		initValues() {
			if (this.data.id) return;
			this.dataId = null;
			this.dataName = "";
			this.kpi = null;
			this.maintainHrs = null;

			this.$validator.reset();
		},
		handleCreateOrUpdateSuccess() {
			this.initValues();
			if (this.data.pivot_id) {
				this.$emit("closePopup");
			}
			this.isFormDirty = false;
			this.$store.dispatch("deviceManagement/fetchCategories", {
				limit: -1,
				fetchPolicy: "no-cache"
			});
			this.$helper.notifySuccess({
				context: this,
				options: {
					text: this.$t(`${this.data.pivot_id ? "UpdateChecklistItemSuccessful" : "CreateChecklistItemSuccessful"}`)
				}
			});
		},
		async handleCreateOrUpdateChecklistItem(dataObj) {
			this.$vs.loading();
			let response;
			try {
				try {
					if (dataObj.pivot_id) {
						response = await this.$store.dispatch("deviceManagement/updateKpiv2ToObject", dataObj);
					} else {
						response = await this.$store.dispatch("deviceManagement/addKpiv2ToObject", dataObj);
					}
					this.handleCreateOrUpdateSuccess(response);
				} catch (error) {
					this.$helper.notifyError({ context: this, error });
					console.error("handleCreateOrUpdateChecklistItem", error);
				}
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		submitData() {
			this.$validator.validateAll().then(result => {
				if (result) {
					if (this.isInvalidName) {
						this.$helper.notifyError({
							context: this,
							options: {
								text: this.$t("DuplicateChecklistItemName")
							}
						});
					} else {
						let dataObj = {
							kpiable_id: this.categoryId,
							kpiable_type: this.$constant.KPIV2.KPIABLE_TYPE.CATEGORY,
							maintain_hrs: this.maintainHrs
						};
						if (this.dataId) {
							dataObj = { ...dataObj, pivot_id: this.data.pivot_id };
						}
						if (this.kpi && this.kpi.id) {
							dataObj = { ...dataObj, kpi_v2_id: this.kpi.id };
						} else {
							dataObj = { ...dataObj, name: this.kpi.name };
						}
						this.handleCreateOrUpdateChecklistItem(dataObj);
					}
				}
			});
		},
		async fetchKpiv2s() {
			try {
				const response = await this.$store.dispatch("deviceManagement/fetchKpisV2", {});
				if (response) {
					this.kpiv2s = response.kpisv2 || [];
				}
			} catch (error) {
				console.error("fetchKpiv2s", error);
			}
		},
		handleAddingNewOption(newOptionText, listOptions) {
			const existedOption = listOptions.find(option => option.name === newOptionText);
			if (!existedOption) {
				return { name: newOptionText };
			}
			return existedOption;
		}
	},
	computed: {
		isPopupActiveLocal: {
			get() {
				return this.isPopupActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closePopup");
				}
			}
		},
		computedFormData() {
			return {
				dataId: this.dataId,
				dataName: this.dataName,
				categoryId: this.categoryId,
				kpi: this.kpi,
				maintainHrs: this.maintainHrs
			};
		},
		isInvalidName() {
			return !!_.find(this.$store.state.deviceManagement.kpiDetails, kpiDetail => kpiDetail.id !== this.dataId && kpiDetail.name.toLowerCase() === this.dataName.toLowerCase());
		}
	},
	created() {
		this.fetchKpiv2s();
	}
};
</script>

<style lang="scss" scoped>
.custom-nested-dialog ::v-deep .el-dialog {
	max-height: 254px;
}
</style>
